export default "__VITE_ASSET__Cs$293Cm__"